var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.4126 4.49997C6.44771 3.71214 6.79162 2.96981 7.36991 2.43363C7.9482 1.89744 8.71436 1.61053 9.5026 1.63497H12.7501C13.5434 1.60243 14.3173 1.88572 14.9021 2.42275C15.487 2.95978 15.835 3.70675 15.8701 4.49997V13.5C15.837 14.2945 15.4897 15.0434 14.9047 15.582C14.3196 16.1207 13.5447 16.405 12.7501 16.3725H9.5026C8.71312 16.3969 7.94587 16.1089 7.36737 15.5711C6.78886 15.0334 6.44579 14.2891 6.4126 13.5V4.49997Z",
    fill: "#EB6270"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4824 8.43752H4.04988L5.28738 7.20752C5.39271 7.10205 5.45188 6.95909 5.45188 6.81002C5.45188 6.66096 5.39271 6.51799 5.28738 6.41252C5.23579 6.36059 5.17445 6.31938 5.10687 6.29126C5.03929 6.26314 4.96682 6.24866 4.89363 6.24866C4.82043 6.24866 4.74796 6.26314 4.68038 6.29126C4.61281 6.31938 4.55146 6.36059 4.49988 6.41252L2.29488 8.60252C2.18954 8.70799 2.13037 8.85096 2.13037 9.00002C2.13037 9.14909 2.18954 9.29205 2.29488 9.39752L4.49988 11.5875C4.55155 11.6405 4.61341 11.6824 4.68173 11.7107C4.75005 11.7391 4.82341 11.7533 4.89738 11.7525C4.97128 11.7529 5.04451 11.7385 5.11277 11.7101C5.18103 11.6818 5.24294 11.6401 5.29488 11.5875C5.40021 11.4821 5.45938 11.3391 5.45938 11.19C5.45938 11.041 5.40021 10.898 5.29488 10.7925L4.04988 9.56252H11.4824C11.6316 9.56252 11.7746 9.50326 11.8801 9.39777C11.9856 9.29228 12.0449 9.14921 12.0449 9.00002C12.0449 8.85084 11.9856 8.70776 11.8801 8.60228C11.7746 8.49679 11.6316 8.43752 11.4824 8.43752Z",
    fill: "#EB6270"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitRed);
export default __webpack_public_path__ + "static/media/exit-red.b3cecba683d503d453250e36b8cb1268.svg";
export { ForwardRef as ReactComponent };